import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./reviews.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import * as kagekiri from 'kagekiri';
import { PopoverHorizontalOrientation, PopoverVerticalOrientation } from 'wds/popover';
import equalityFn from 'zustand/shallow';
import { BadgeVariant, generateBadgeTooltips } from '~/modules/helpers/badgeHelper';
import { Routes } from '~/modules/routes';
import { DeleteReviewStatus, LoadingStatus, SortBy, WriteReviewStatus } from '~/modules/services/reviewService';
import { WireI18n, i18nStore } from '~/modules/stores/i18nStore';
import { DEFAULT_PAGE_LENGTH, reviewStore } from '~/modules/stores/reviewStore';
import { navigate, routerStore, selectScrollToQueryParam } from '~/modules/stores/routerStore';
import { selectUserReviewEligibility, userStore } from '~/modules/stores/userStore';
import { DeviceType, selectDeviceType, viewportStore } from '~/modules/stores/viewportStore';
import { scrollToElement } from '~/modules/utilities/browser';
import { sendNotification } from '~/modules/utilities/notificationUtilities';
import { upsertQueryParams } from '~/modules/utilities/router';
const REVIEW_FEATURES_KEYS = ['salesforceMVP', 'topContributor', 'trailheadRank'];
class Reviews extends LightningElement {
  constructor(...args) {
    super(...args);
    this.reviewSummary = void 0;
    // @ts-expect-error * Automated Type Error Fix
    this.badgesLabels = null;
    // @ts-expect-error * Automated Type Error Fix
    this.reviewsLabels = null;
    // @ts-expect-error * Automated Type Error Fix
    this.reviewLabels = null;
    // @ts-expect-error * Automated Type Error Fix
    this.filterChipLabels = null;
    this.loadingStatus = LoadingStatus.UNINITILIAZED;
    this.userAuthenticated = false;
    this.isUserReviewLoading = false;
    this.isSingleReviewLoading = false;
    this.deleteReviewStatus = DeleteReviewStatus.AVAILABLE;
    this.writeReviewStatus = WriteReviewStatus.AVAILABLE;
    this.isLoadingUser = false;
    this.hasListingReviewsError = false;
    this.singleReviewId = '';
    this.listingReviews = {
      reviews: [],
      hasNext: false,
      total: 0
    };
    // @ts-expect-error * Automated Type Error Fix
    this.userReview = null;
    this.displayTooltip = false;
    this.reviewSortCriteria = SortBy.RECENT;
    this.sort = '';
    this.displayWriteReviewPopover = false;
    this.showWriteReviewModal = false;
    this.shouldAutoFocusWriteReviewModal = false;
    this.writeButton = '';
    this.hasWritten = false;
    // @ts-expect-error * Automated Type Error Fix
    this.singleReview = null;
    // @ts-expect-error * Automated Type Error Fix
    this._filter = null;
    this.reviewsCount = 0;
    this.loadMoreError = '';
    this.displayMobileFilterPanel = false;
    this.focusOnMobileFilterPanel = false;
    this.
    // @ts-expect-error * Automated Type Error Fix
    scrollToParam = void 0;
    this.deviceType = void 0;
  }
  setUserState(userState) {
    this.userAuthenticated = !userState.isGuestUser;
    this.isLoadingUser = userState.isLoading;
    this.canWriteReview = userState.canWriteReview;
  }
  i18nCallback(i18n) {
    this.badgesLabels = i18n.listingDetails.badges;
    this.reviewsLabels = i18n.listingDetails.reviews;
    this.reviewLabels = i18n.listingDetails.review;
    this.filterChipLabels = {
      '1': this.reviewsLabels.filterChips.rating.oneStarRating,
      '2': this.reviewsLabels.filterChips.rating.twoStarRating,
      '3': this.reviewsLabels.filterChips.rating.threeStarRating,
      '4': this.reviewsLabels.filterChips.rating.fourStarRating,
      '5': this.reviewsLabels.filterChips.rating.fiveStarRating,
      hmvp: this.reviewsLabels.filterChips.user.mvp,
      htr: this.reviewsLabels.filterChips.user.ranger,
      htc: this.reviewsLabels.filterChips.user.topContributor
    };
  }
  // ELEMENT REFERENCES
  get sortButtonRef() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('[data-id="sortButton"]');
  }
  get sortOptionsGroupRef() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('[data-id="sortOptions"]');
  }
  get activeSortOptionRef() {
    const {
      value,
      shadowRoot
    } = this.sortOptionsGroupRef ?? {};
    // @ts-expect-error * Automated Type Error Fix
    return value ? shadowRoot.querySelector(`input#${value}`) : undefined;
  }
  get applyFilterButtonRef() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('.add-filter-button');
  }
  get filterPanelActiveElementRef() {
    // @ts-expect-error * Automated Type Error Fix
    return kagekiri.querySelector('input:focus', this.template.activeElement);
  }
  get filterPanelCloseButtonRef() {
    return this.template.querySelector('.close-button');
  }
  get filterPanelfocusableElementsRef() {
    return kagekiri.querySelectorAll('[id="filters-panel"] input[type="checkbox"]');
  }
  get filterPanelFirstElementRef() {
    return this.filterPanelfocusableElementsRef[0];
  }
  get filterPanelLastElementRef() {
    return this.filterPanelfocusableElementsRef[this.filterPanelfocusableElementsRef.length - 1];
  }
  get popoverOrientation() {
    const popoverOrientation = {
      vertical: PopoverVerticalOrientation.BOTTOM,
      horizontal: PopoverHorizontalOrientation.CENTER
    };
    return popoverOrientation;
  }
  renderedCallback() {
    scrollToElement(this, this.scrollToParam);
    if (this.displayTooltip) {
      this.activeSortOptionRef?.focus();
    }
    this.focusOnMobileFilterPanel = false;
  }
  setCurrentReviews(reviewState) {
    this.loadingStatus = reviewState.loadingStatus;
    this._filter = reviewState.filter;
    this.sort = reviewState.sort;
    this.isUserReviewLoading = reviewState.isUserReviewLoading;
    this.isSingleReviewLoading = reviewState.isLoadingSingleReview;
    this.singleReviewId = reviewState.singleReviewId;
    // @ts-expect-error * Automated Type Error Fix
    this.singleReview = reviewState.singleReview;
    this.hasListingReviewsError = reviewState.hasListingReviewsError;
    this.loadMoreError = reviewState.loadMoreError;
    this.deleteReviewStatus = reviewState.deleteReviewStatus;
    this.writeReviewStatus = reviewState.writeReviewStatus;
    if (reviewState.listingReviews) {
      this.listingReviews = reviewState.listingReviews;
    }
    if (reviewState.userReview) {
      this.userReview = reviewState.userReview;
    }
  }
  // @ts-expect-error * Automated Type Error Fix
  switchMobileFilterPanel(event) {
    this.displayMobileFilterPanel = !this.displayMobileFilterPanel;

    // If event.detail is zero, that means the event was triggered by a keyboard press
    if (event.detail === 0) {
      if (this.displayMobileFilterPanel) {
        this.focusOnMobileFilterPanel = true;
      } else {
        this.applyFilterButtonRef?.focus();
      }
    }
  }
  get isDesktopOrSorting() {
    return this.deviceType === DeviceType.DESKTOP || this.loadingStatus === LoadingStatus.SORTING;
  }
  get isMobilePhone() {
    return this.deviceType === DeviceType.PHONE;
  }
  get shouldDisplayFilters() {
    return !this.mobileFilterPanel || this.displayMobileFilterPanel;
  }
  get contentGap() {
    return !this.mobileFilterPanel ? 'x-large' : 'none';
  }
  get switcherButtonType() {
    return this.isMobilePhone ? 'wide-extrasmall' : 'extrasmall';
  }
  get buttonVariant() {
    return this.isMobilePhone ? 'secondary' : 'tertiary';
  }
  get mobileFilterChips() {
    return this.showFilterChips && this.mobileFilterPanel;
  }
  get desktopFilterChips() {
    return this.showFilterChips && !this.mobileFilterPanel;
  }
  get isFiltering() {
    return this.loadingStatus === LoadingStatus.FILTERING;
  }
  get mobileFilterPanel() {
    return this.deviceType !== DeviceType.DESKTOP;
  }
  get addFilterButtonText() {
    if (this.filterChips.length > 0) {
      return i18nStore.getState().i18n.listingDetails.reviews.filtersButtonWithAmount({
        AMOUNT: this.filterChips.length
      });
    }
    return this.reviewsLabels.applyFiltersButton;
  }
  get closeButtonText() {
    if (this.loadingStatus === LoadingStatus.FILTERING) {
      return this.reviewsLabels.loading;
    }
    return this.filterChips.length > 0 ? i18nStore.getState().i18n.listingDetails.reviews.showFilterResults({
      AMOUNT: this.listingReviews.reviews.length
    }) : this.reviewsLabels.closeFilterPanel;
  }
  get totalReviews() {
    return i18nStore.getState().i18n.listingDetails.reviews.totalReviews({
      TOTAL_REVIEWS: this.reviewSummary.reviewCount
    });
  }
  get showSingleReview() {
    return this.singleReviewId && !this.isSingleReviewLoading && this.singleReview;
  }
  get writeButtonLabel() {
    if (!this.userReview?.questionnaireResponseId) {
      return this.reviewsLabels.emptyState.writeBtn;
    }
    return this.reviewsLabels.emptyState.editBtn;
  }
  handleLoadMore() {
    navigate(`${Routes.LISTING}?${upsertQueryParams({
      remove: ['scrollTo', 'selected-review']
    })}`);
    reviewStore.loadMore(this.reviewSummary.listingId, DEFAULT_PAGE_LENGTH);
  }
  get averageRating() {
    return this.reviewSummary.averageRating;
  }
  get reviewCountLabel() {
    if (!this.hasListingReviewsError) {
      return i18nStore.getState().i18n.listingDetails.reviews.reviewsSummaryFilterLabel({
        FILTERED_REVIEWS: this.listingReviews.reviews.length,
        TOTAL_REVIEWS: this.reviewSummary.reviewCount
      });
    }
    return i18nStore.getState().i18n.listingDetails.reviews.errorState.reviewsSummaryLabel({
      TOTAL_REVIEWS: this.listingReviews.total
    });
  }
  get ratingSummaryLabel() {
    return this.reviewsLabels.reviewsRating;
  }
  get reviewEmptyLabels() {
    if (this.showEmptyFilteredReviews) {
      return {
        title: this.reviewsLabels.emptyFilteredState.title,
        description: this.reviewsLabels.emptyFilteredState.description
      };
    }
    return {
      title: this.reviewsLabels.emptyState.title,
      description: this.reviewsLabels.emptyState.description,
      writeBtn: this.reviewsLabels.emptyState.writeBtn
    };
  }
  get showEmptyState() {
    return this.listingReviews.reviews.length === 0 && reviewStore.areFiltersEmpty() && reviewStore.getState().loadingStatus === LoadingStatus.LOADED && !this.hasListingReviewsError;
  }
  get writeReviewButtonRef() {
    return kagekiri.querySelector('.write-review-button');
  }
  get showEmptyFilteredReviews() {
    return !this.hasListingReviewsError && this.listingReviews.reviews.length === 0 && !reviewStore.areFiltersEmpty() && this.loadingStatus === LoadingStatus.LOADED;
  }
  get showMoreReviews() {
    return this.listingReviews.hasNext;
  }
  get firstTime() {
    if (this.writeReviewStatus === WriteReviewStatus.IN_PROGRESS || this.deleteReviewStatus === DeleteReviewStatus.IN_PROGRESS) {
      return false;
    }
    return this.loadingStatus === LoadingStatus.LOADING || this.isUserReviewLoading || this.isLoadingUser;
  }
  get filteringOrSorting() {
    return this.loadingStatus === LoadingStatus.FILTERING || this.loadingStatus === LoadingStatus.SORTING;
  }
  get moreReviewsButton() {
    const isLoadingMore = this.loadingStatus === LoadingStatus.LOADING_MORE;
    const label = isLoadingMore ? this.reviewsLabels.loadingMoreReviews : this.reviewsLabels.showMore;
    return {
      show: this.listingReviews.hasNext,
      label: label,
      disabled: isLoadingMore
    };
  }
  get sortOptions() {
    const sortOptions = [{
      value: SortBy.RECENT,
      label: this.reviewsLabels.sort.mr
    }, {
      value: SortBy.HELPFUL,
      label: this.reviewsLabels.sort.mh
    }, {
      value: SortBy.FAVORABLE,
      label: this.reviewsLabels.sort.mf
    }];
    return sortOptions;
  }
  get sortValue() {
    return this.sort;
  }
  get sortButtonLabel() {
    return i18nStore.getState().i18n.listingDetails.reviews.sort.button({
      // @ts-expect-error * Automated Type Error Fix
      criteria: this.reviewsLabels.sort[this.sort]
    });
  }
  get filters() {
    const starOptions = [{
      type: 'stars',
      value: '5'
    }, {
      type: 'stars',
      value: '4'
    }, {
      type: 'stars',
      value: '3'
    }, {
      type: 'stars',
      value: '2'
    }, {
      type: 'stars',
      value: '1'
    }];
    const badgeOptions = [{
      type: 'badge',
      label: this.badgesLabels.salesforceMVP,
      value: 'hmvp',
      badge: {
        variant: BadgeVariant.Purple
      }
    }, {
      type: 'badge',
      label: this.badgesLabels.trailheadRank,
      value: 'htr',
      badge: {
        variant: BadgeVariant.Blue
      }
    }, {
      type: 'badge',
      label: this.badgesLabels.topContributor,
      value: 'htc',
      badge: {
        variant: BadgeVariant.HotOrange
      }
    }];
    return [{
      key: 'rating-section',
      label: this.reviewsLabels.filter.rating,
      name: 'rating',
      multiple: true,
      noLabeledStars: true,
      noSectionToggle: true,
      selectedValue: this._filter.rating,
      shouldFocusFirstElement: this.focusOnMobileFilterPanel,
      options: starOptions
    }, {
      key: 'badge-section',
      label: this.reviewsLabels.filter.badge,
      name: 'badge',
      multiple: true,
      noSectionToggle: true,
      selectedValue: this._filter.badge,
      options: badgeOptions,
      tooltip: this.userBadgestooltipValues,
      tooltipPlacement: 'top'
    }];
  }
  get reviewerName() {
    return i18nStore.getState().i18n.listingDetails.reviews.singleReview.title({
      REVIEWER: this.singleReview?.user?.name ?? ''
    });
  }
  get filterChips() {
    const badgeFilterChips = this._filter.badge.map(filter => {
      return {
        section: 'badge',
        label: this.filterChipLabels[filter],
        value: filter
      };
    });
    const ratingFilterChips = this._filter.rating.map(filter => {
      return {
        section: 'rating',
        label: this.filterChipLabels[filter],
        value: filter
      };
    });
    return badgeFilterChips.concat(ratingFilterChips);
  }
  get showFilterChips() {
    return this.filterChips.length > 0;
  }
  get ratingReviewSummaryLabelPosition() {
    return this.isMobilePhone ? 'right' : 'top';
  }
  get userBadgestooltipValues() {
    return generateBadgeTooltips(REVIEW_FEATURES_KEYS);
  }
  toggleTooltip() {
    if (this.displayTooltip === false) {
      this.hidePopover();
    } else {
      this.closePopover();
    }
  }
  hidePopover() {
    this.displayTooltip = true;
  }
  closePopover() {
    this.displayTooltip = false;
    this.sortButtonRef.focus();
  }
  handleSortSelectionChange(event) {
    const {
      value: [selectedOption],
      clicked
    } = event.detail;
    reviewStore.setSort(this.reviewSummary.listingId, selectedOption);

    // hide dropdown if change was triggered by mouse click
    if (clicked) {
      this.closePopover();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleTooltipKeyboardEvent(event) {
    if (event.key === 'Escape' || event.key === 'Enter') {
      event.preventDefault();
      this.closePopover();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleFilterPanelKeyboardEvent(event) {
    if (this.displayMobileFilterPanel) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.switchMobileFilterPanel(event);
      }
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          if (this.filterPanelActiveElementRef === this.filterPanelFirstElementRef) {
            this.filterPanelCloseButtonRef.focus();
            event.preventDefault();
          }
        }
      }
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleFilterPanelCloseButtonKeyboardEvent(event) {
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        this.filterPanelLastElementRef.focus();
        event.preventDefault();
      } else {
        this.filterPanelFirstElementRef.focus();
        event.preventDefault();
      }
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      this.switchMobileFilterPanel(event);
    }
  }
  async likeReview(event) {
    if (!this.userAuthenticated) {
      window.SFIDWidget.login();
      return;
    }
    const previousFocusedElement = event.detail.originalTarget;
    const response = await reviewStore.likeReview(event.detail.reviewId);
    if (response.isSuccess === false) {
      const {
        errorMessage,
        exceptionInfo
      } = response;
      // @ts-expect-error * Automated Type Error Fix
      sendNotification(errorMessage, {
        exceptionInfo,
        previousFocusedElement
      });
    }
  }
  async unlikeReview(event) {
    if (!this.userAuthenticated) {
      window.SFIDWidget.login();
      return;
    }
    const previousFocusedElement = event.detail.originalTarget;
    const response = await reviewStore.unlikeReview(event.detail.reviewId, event.detail.likeId);
    if (response.isSuccess === false) {
      const {
        errorMessage,
        exceptionInfo
      } = response;
      // @ts-expect-error * Automated Type Error Fix
      sendNotification(errorMessage, {
        exceptionInfo,
        previousFocusedElement
      });
    }
  }
  handleFilterChange(event) {
    reviewStore.setFilter(this.reviewSummary.listingId, event.detail);
  }
  handleChipClose(event) {
    reviewStore.removeFilter(this.reviewSummary.listingId, event.detail);
  }
  toggleWriteReviewPopover() {
    if (this.isNewUser) {
      if (this.displayWriteReviewPopover === false) {
        this.openWriteReviewPopover();
      } else {
        this.closeWriteReviewPopover();
      }
    } else {
      this.openReviewModal();
    }
  }
  openWriteReviewPopover() {
    this.displayWriteReviewPopover = true;
  }
  closeWriteReviewPopover() {
    this.displayWriteReviewPopover = false;
    this.writeReviewButtonRef?.focus();
  }
  handleWriteReviewPopoverKeyboardEvent(event) {
    if (event.key === 'Escape' || event.key === 'Enter') {
      event.preventDefault();
      this.closeWriteReviewPopover();
    }
  }
  openReviewModal(event) {
    if (!this.userAuthenticated) {
      window.SFIDWidget.login();
      return;
    }
    this.showWriteReviewModal = true;
    // https://stackoverflow.com/a/69854905
    this.shouldAutoFocusWriteReviewModal = event?.detail !== 0;
  }
  closeReviewModal() {
    this.showWriteReviewModal = false;
    this.writeReviewButtonRef?.focus();
  }
  navigateSingleReviewURL(event) {
    navigate(`${Routes.LISTING}?${upsertQueryParams({
      insert: [['scrollTo', 'selected-review'], ['revId', `${event.detail.review.id}`]]
    })}`);
  }
  get isNewUser() {
    return !this.canWriteReview;
  }
  get writeReviewDisabledMessage() {
    return this.reviewsLabels.newUserMessage;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Reviews, {
  publicProps: {
    reviewSummary: {
      config: 0
    }
  },
  wire: {
    setUserState: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectUserReviewEligibility,
          equalityFn
        };
      }
    },
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    scrollToParam: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: routerStore,
          selector: selectScrollToQueryParam
        };
      }
    },
    setCurrentReviews: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: reviewStore
        };
      }
    },
    deviceType: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: viewportStore,
          selector: selectDeviceType
        };
      }
    }
  },
  fields: ["badgesLabels", "reviewsLabels", "reviewLabels", "filterChipLabels", "loadingStatus", "userAuthenticated", "isUserReviewLoading", "isSingleReviewLoading", "deleteReviewStatus", "writeReviewStatus", "isLoadingUser", "hasListingReviewsError", "singleReviewId", "listingReviews", "userReview", "displayTooltip", "reviewSortCriteria", "sort", "displayWriteReviewPopover", "showWriteReviewModal", "shouldAutoFocusWriteReviewModal", "writeButton", "hasWritten", "singleReview", "_filter", "reviewsCount", "loadMoreError", "displayMobileFilterPanel", "focusOnMobileFilterPanel"]
});
const __lwc_component_class_internal = _registerComponent(Reviews, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;